import request from "@/utils/request";
//1, 查询单个设备的详情
export function getDeviceDetail(data){
    return request({
        url:'/getDeviceDetail',
        data:data,
        method:'get'
    })
}
//2, 查询设备列表
// name 设备名称
// device_category_id 设备分类 id
// institution_id 设备所属机构 id
export function getDevices(data){
    return request({
        url:'/getDevices',
        data:data,
        method:'get'
    })
}

// 3, 用户收藏设备，需登录后 id int // 待收藏的设备 id
export function collectDevice(data){
    return request({
        url:'/web/collectDevice',
        data:data,
        method:'post'
    })
}

//4, 用户收藏设备的列表
export function myCollectDevices(data){
    return request({
        url:'/web/myCollectDevices',
        data:data,
        method:'get'
    })
}

//5, 取消收藏
export function uncollectDevice(data){
    return request({
        url:'/web/uncollectDevice',
        data:data,
        method:'post'
    })
}

